import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import dataAids from '../../../../constants/dataAids';
import {
  imageZoomContainerStyles,
  zoomHelperStyles,
  lightboxCloseStyles
} from '../../../../constants/constants';
import ImageZoom from './ImageZoom';
import PropTypes from 'prop-types';

export default class ZoomLightbox extends React.Component {
  constructor() {
    super();
    this.state = {
      // eslint-disable-next-line new-parens
      containerId: 'zoom-lightbox-container-' + +new Date(),
      isZooming: false,
      hasRenderedImage: false
    };

    this.handleClose = this.handleClose.bind(this);
    this.handleDeviceRotate = this.handleDeviceRotate.bind(this);
    this.enableScrolling = this.enableScrolling.bind(this);
    this.disableScrolling = this.disableScrolling.bind(this);
  }

  UNSAFE_componentWillMount() {
    this._initialOverflow = null;
  }

  componentDidMount() {
    window.addEventListener('orientationchange', this.handleDeviceRotate);
    window.addEventListener('resize', this.handleDeviceRotate);
  }

  componentWillUnmount() {
    window.removeEventListener('orientationchange', this.handleDeviceRotate);
    window.removeEventListener('resize', this.handleDeviceRotate);
    this.enableScrolling();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.visible && nextProps.visible === false) {
      this.setState({ hasRenderedImage: false });
      this.enableScrolling();
    } else if (nextProps.visible) {
      this.disableScrolling();
    }
  }

  handleDeviceRotate() {
    this.forceUpdate();
  }

  handleClose(e) {
    const { onClose } = this.props;
    const { containerId } = this.state;

    if (e.target && e.target.id === containerId) {
      onClose();
    }
  }

  disableScrolling() {
    const { renderMode } = this.props;
    if (this._initialOverflow === null && renderMode === 'PUBLISH') {
      this._initialOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
  }

  enableScrolling() {
    const { renderMode } = this.props;
    if (renderMode === 'PUBLISH') {
      document.body.style.overflow = this._initialOverflow;
      this._initialOverflow = null;
    }
  }

  render() {
    const { src, srcLarge, alt, visible, onClose, renderMode, helpText } = this.props;
    const { containerId, isZooming } = this.state;
    const { Block } = UX2.Element;

    if (!visible) {
      return null;
    }

    const imageClassName = 'ols-lightbox-zoom-image';

    const padding = 40;
    const paddingPreview = 10;

    let maxWidth = document.documentElement.clientWidth - padding;
    let maxHeight = window.innerHeight - padding;

    const isPreview = renderMode !== 'PUBLISH';
    const viewport = isPreview ? document.querySelector('.viewport') : null;

    const imageElement = document.querySelector(`.${imageClassName}`);
    if (imageElement) {
      const rect = imageElement.getBoundingClientRect();
      const bottom = Math.abs(rect.bottom - rect.height) + 10;
      zoomHelperStyles.bottom = `${bottom}px`;
    }

    if (isPreview && viewport) {
      const viewportSize = viewport.getBoundingClientRect();
      maxWidth = viewportSize.width - paddingPreview;
      maxHeight = viewportSize.height - paddingPreview;
    }

    const renderCallback = function () {
      if (this.state.hasRenderedImage) {
        return null;
      }
      return () => this.setState({ hasRenderedImage: true });
    }.bind(this);

    return (
      <Block
        id={ containerId }
        data-aid={ dataAids.PRODUCT_ASSET_MOBILE_ZOOM_RENDERED }
        style={ imageZoomContainerStyles }
        onClick={ this.handleClose }
        onTouchStart={ () => this.setState({ isZooming: true }) }
        onTouchEnd={ () => this.setState({ isZooming: false }) }
      >
        { !isZooming ? <Block style={ zoomHelperStyles } children={ helpText } /> : null }
        <ImageZoom
          src={ src }
          srcLarge={ srcLarge }
          alt={ alt }
          maxWidth={ maxWidth }
          maxHeight={ maxHeight }
          enlargedImagePosition='over'
          imageClassName={ imageClassName }
          renderCallback={ renderCallback() }
          style={{ backgroundColor: '#fff' }}
          aspectRatio={ 1 }
        />
        <Block style={ lightboxCloseStyles } onClick={ onClose } children='&times;' />
      </Block>
    );
  }
}

ZoomLightbox.propTypes = {
  src: PropTypes.string,
  srcLarge: PropTypes.string,
  alt: PropTypes.string,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  renderMode: PropTypes.string,
  helpText: PropTypes.string
};
